import classNames from 'classnames'
import React, {PropsWithChildren} from 'react'
import {Button, ButtonPriority, HoverStyles} from 'wix-ui-tpa/cssVars'
import {classes} from './join-button.st.css'

interface JoinButtonProps {
  onClick: () => void
  dataHook?: string
  className?: string
}

export const JoinButton = ({className, onClick, dataHook, children}: PropsWithChildren<JoinButtonProps>) => (
  <Button
    upgrade
    priority={ButtonPriority.secondary}
    className={classNames(classes.root, className)}
    onClick={onClick}
    data-hook={dataHook}
    hoverStyle={HoverStyles.underline}
  >
    {children}
  </Button>
)
